// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2_qOu","overflowing":"ReadFullNote_overflowing__1zcH7"};